module.exports = __webpack_public_path__ + "img/header-img.3fef8c44.jpg";